import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck from '@/components/common/PermissionCheck';

const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
  showBranchCol, // show when viewing All branches
}) => (
  <TableWrapServerSide
    tableColumnList={tableColumn}
    totalDataCount={totalRecord}
    initialPage={dataFilter.page}
    onChangePage={onChangePage}
    per_page={dataFilter.limit}
  >
    {dataSource && dataSource.length > 0 ? (
      dataSource.map((inv) => (
        <tr className="db-table-body-tr" key={inv._id}>
          <td className="db-table-body-td">{inv.item?.name || 'N/A'}</td>
          <td className="db-table-body-td">{inv.item_category?.name || 'N/A'}</td>
          {showBranchCol && <td className="db-table-body-td">{inv.branch?.name || '—'}</td>}
          <td className="db-table-body-td">
            {inv.item_category?.isPerishable ? <span className="text-emerald-600">Yes</span> : <span className="text-gray-500">No</span>}
          </td>
          <td className="db-table-body-td">{inv.quantity}</td>
          <td className="db-table-body-td">{inv.price != null ? `$${inv.price}` : 'N/A'}</td>
          <td className="db-table-body-td">
            {inv.status === 1 ? <span className="active">Active</span> : inv.status === 2 ? <span className="inactive">Inactive</span> : <span className="archived">Archived</span>}
          </td>
          <td className="db-table-body-td hidden-print hidden-print-remove">
            <div className="flex gap-1.5">
              <PermissionCheck permission="view_item">
                <Link to={`/admin/item/show/${inv.item?._id}`}>
                  <button className="db-table-action view" type="button">
                    <i className="lab lab-view" />
                    <span className="db-tooltip">view</span>
                  </button>
                </Link>
              </PermissionCheck>
              <PermissionCheck permission="update_inventory">
                <button className="db-table-action edit" onClick={() => handleDrawerOpen(inv._id)}>
                  <i className="lab lab-edit-line" />
                  <span className="db-tooltip">edit</span>
                </button>
              </PermissionCheck>
              <PermissionCheck permission="delete_inventory">
                <button className="db-table-action delete" onClick={() => deleteRecord(inv._id)}>
                  <i className="lab lab-delete" />
                  <span className="db-tooltip">delete</span>
                </button>
              </PermissionCheck>
            </div>
          </td>
        </tr>
      ))
    ) : (
      <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
    )}
  </TableWrapServerSide>
);

export default DataTable;
